<template>
  <div>
    <lcontainer class="mb-4">
      <div class="heading flex flex-row items-center justify-between p-8">
        <div>
          <div class="page text-white">User Details</div>
        </div>
        <div></div>
      </div>
    </lcontainer>
    <div>
      <lcontainer>
        <lCrumbs class="py-4 px-8" :breadcrumb="breadcrumbItems" />
        <div class="py-4 px-8 flex flex-wrap">
          <div class="w-full md:w-1/2 items-center form-row my-4 px-4">
            <div class="flex flex-wrap justify-between">
              <page-header class="py-2 tenant-main-color"
                >User Information</page-header
              >
            </div>
            <div class="text-capitalize">
              <div class="flex justify-between flex-wrap my-4">
                <p class="font-bold tenant-main-color">First Name:</p>
                <p class="text-md">{{ user.first_name }}</p>
              </div>

              <div class="flex justify-between flex-wrap my-4">
                <p class="font-bold tenant-main-color">Last Name:</p>
                <p class="text-md">{{ user.last_name }}</p>
              </div>

              <div class="flex justify-between flex-wrap my-4">
                <p class="font-bold tenant-main-color">Email:</p>
                <p class="text-md">{{ user.email }}</p>
              </div>

              <div class="flex justify-between flex-wrap my-4">
                <p class="font-bold tenant-main-color">Gender:</p>
                <p class="text-md text-capitalize">{{ user.gender }}</p>
              </div>

              <div class="flex justify-between flex-wrap my-4">
                <p class="font-bold tenant-main-color">Bio:</p>
                <p class="text-md text-capitalize">{{ user.bio }}</p>
              </div>

              <div class="flex justify-between flex-wrap my-4">
                <p class="font-bold tenant-main-color">Completed Courses:</p>
                <p class="text-md text-capitalize">
                  {{ user.courses_completed }}
                </p>
              </div>
              <div class="flex justify-between flex-wrap my-4">
                <p class="font-bold tenant-main-color">Courses in progress:</p>
                <p class="text-md text-capitalize">
                  {{ user.courses_in_progress }}
                </p>
              </div>
              <div class="flex justify-between flex-wrap my-4">
                <p class="font-bold tenant-main-color">Points Earned:</p>
                <p class="text-md text-capitalize">{{ user.reward_point }}</p>
              </div>
            </div>
          </div>
          <div class="w-full md:w-1/2 items-center form-row my-6 px-4">
            <page-header class="py-2 tenant-main-color">Badges</page-header>
            <ul class=" md:px-12 flex flex-wrap">
              <li v-for="badge in user.badges" :key="badge.id">
                {{ badge.title }}
              </li>
            </ul>
          </div>
        </div>
      </lcontainer>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  components: {
    LmsButton: () => import("@/components/general/button"),
    lcontainer: () => import("@/components/general/container"),
    LmsTable: () => import("@/components/admin/admin-table"),
    PageHeader: () => import("@/components/general/pageheader"),
    LmsSelect: () => import("@/components/forms/select"),
    linput: () => import("@/components/general/input"),
    lselect: () => import("@/components/forms/select"),
    ltextarea: () => import("@/components/general/textarea"),
    LmsOutlineButton: () => import("@/components/general/outline_button"),
    lCrumbs: () => import("@/components/general/breadcrumbs.vue"),
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  data() {
    return {
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        gender: "",
        role: "",
      },
      errors: [],
      error: {},
      user: {},
      search: "",
      breadcrumbItems: [
        {
          disabled: true,
          to: "/tenant/discussion/",
          text: "All Boards",
        },
        {
          disabled: true,
          to: `back`,
          text: `lesson`,
          text: `Discussion Board`,
        },
        {
          disabled: true,
          to: `#`,
          text: `lesson`,
          text: `User`,
        },
      ],
    };
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions([
      "fetchAdminRoles",
      "updateProfile",
      "fetchProfile",
      "fetchUserDetailsProfile",
    ]),
  },
  async mounted() {
  
      this.updateLoader(true);
      let res = await this.fetchUserDetailsProfile({
        id: this.$route.params.user,
      });
   
      this.user = res.data.data.user;
      this.updateLoader(false);
      
    
  },
};
</script>
<style scoped>
li {
  list-style: circle;
}
</style>
